import { eventLookupsService } from "client-app-core";
import * as t from "./actionTypes";

const eventLookupsReceived = (data) => {
	return {
		type: t.EVENT_LOOKUPS_RECEIVED,
		payload: data
	};
};

export const getEventLookups = () => {
	return (dispatch) => {
		eventLookupsService.getAll((err, res) => {
			if (err) {
				console.log("Event Lookup Service error received", err);
			} else {
				dispatch(eventLookupsReceived(res));
			}
		});
	};
};
